module.exports = __webpack_public_path__ + "img/back.9dd0de57.svg";